/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { UserFlagsType } from '../Login/userSlice';
import styles from './UserFlagsTable.module.scss';

export function UserFlagsTable({
  principalName,
  userFlags,
}: {
  principalName: string | undefined;
  userFlags?: UserFlagsType | undefined;
}) {
  const pearlUserInfo = { principalName, userFlags };
  const currentEnv = process.env.REACT_APP_ENVIRONMENT;
  return (
    <div className={styles.launchdarkly}>
      <table>
        <thead>
          <tr>
            <th>Launch Darkly Flag for {pearlUserInfo.principalName}</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {pearlUserInfo.userFlags &&
            Object.entries(pearlUserInfo.userFlags).map(([key, value]) => (
              <tr key={key} data-value={value}>
                <th>
                  <a
                    href={`https://app.launchdarkly.com/projects/default/flags/${key}/targeting?env=${currentEnv}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {key}
                  </a>
                </th>
                <td>{value?.toString()}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
